import { useTitle } from "react-use";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { TestResultsGrid } from "../components/TestResults";

export function BrowsePage() {
  useTitle("Browse");

  // const { data, isLoading } = trpc.accession.list.all.useQuery({
  //   dateRange: date,
  //   filter: {
  //     status: ["new", "received", "in_progress", "completed"],
  //   },
  // });

  return (
    <>
      <SubHeader>
        <SubHeader.Left>
          <Breadcrumbs>
            <Breadcrumb>Browse</Breadcrumb>
          </Breadcrumbs>
        </SubHeader.Left>
      </SubHeader>
      <TestResultsGrid />
      <CommandMenuProvider>
        <CommandMenu />
      </CommandMenuProvider>
    </>
  );
}
